import { FC } from 'react';
import { Select } from 'antd';
import { AiFillCaretDown } from 'react-icons/ai';
import { FileTypes } from '../../../enums/fileTypes';
import { useLegendForm } from '../../../context/MapLegendContext';

const { Option } = Select;

export interface SelectFileTypeProps {
  handleFileTypeChange: (value: FileTypes) => void;
}

const SelectFileType: FC<SelectFileTypeProps> = ({ handleFileTypeChange }) => {
  const { uploadFileType } = useLegendForm();

  const onChange = (value: FileTypes) => {
    handleFileTypeChange(value);
  };

  return (
    <Select
      placeholder="FILE TYPE"
      className="location-select"
      value={uploadFileType ?? 'File Type'}
      onChange={onChange}
      suffixIcon={<AiFillCaretDown />}
    >
      <Option value={FileTypes.SHAPEFILE}>SHAPEFILE</Option>
      <Option value={FileTypes.RASTER}>RASTER(GEO TIFF)</Option>
      <Option value={FileTypes.GEOJSON}>GEOJSON</Option>
      <Option value={FileTypes.WMS}>WEB MAP SERVICE (WMS)</Option>
      <Option value={FileTypes.KML}>KML</Option>
    </Select>
  );
};

export default SelectFileType;
